export default __webpack_public_path__ + "static/media/WhatsTheWeather.681430bd.JPG";